/**
 * The one place a dashboard number becomes a tile severity (DESIGN.md §7.3). Zero and healthy
 * stay neutral (`undefined`), so a tile only draws attention when something needs it.
 */

export type Severity = 'warning' | 'error';

export const SEVERITY_THRESHOLDS = {
  /** Percent of a capacity used: at or above `error` is an error, at or above `warning` a warning. */
  capacity: { error: 90, warning: 75 },
  /** Success rate in percent: at or above `healthy` is fine, at or above `warning` a warning, below that an error. */
  successRate: { healthy: 95, warning: 80 },
} as const;

export const capacitySeverity = (percentUsed: number): Severity | undefined => {
  const { error, warning } = SEVERITY_THRESHOLDS.capacity;
  return percentUsed >= error ? 'error' : percentUsed >= warning ? 'warning' : undefined;
};

export const successSeverity = (rate: number): Severity | undefined => {
  const { healthy, warning } = SEVERITY_THRESHOLDS.successRate;
  return rate >= healthy ? undefined : rate >= warning ? 'warning' : 'error';
};

/** A backlog (requests to review): any waiting item is a warning; zero is neutral. */
export const backlogSeverity = (count: number): Severity | undefined =>
  count > 0 ? 'warning' : undefined;
